import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { Plugins, PushNotification, Capacitor } from '@capacitor/core';
import { AuthService } from '../services/auth.service';
import { AlertController, ToastController } from '@ionic/angular';
import { MessageService } from '../services/message.service';

const { PushNotifications } = Plugins;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.page.html',
  styleUrls: ['./dashboard.page.scss'],
})
export class DashboardPage implements OnInit {

  messageBadgeCount = null;
  first_name = null;
  last_name = null;
  darkMode = false;
  unreadCount = 0;
  constructor(
    private router:Router, 
    private authService:AuthService, 
    private cdr: ChangeDetectorRef,
    public toastController: ToastController,
    private messageService: MessageService,
    public alertController: AlertController
  ) {
    
   }

  ionViewWillEnter(){
    this.getMessageUnReadCount();
      let isDark = localStorage.getItem('dark_mode');
      if(isDark == 'true'){
        localStorage.setItem('dark_mode', 'true');
        this.darkMode = true;
      }else{
        localStorage.setItem('dark_mode', 'false');
        this.darkMode = false;
      }
      document.body.classList.toggle('dark', this.darkMode);
    this.messageBadgeCount = localStorage.getItem('message_badge_count');
    if(localStorage.getItem('first_name') !== undefined && localStorage.getItem('last_name') !== undefined){
      this.first_name = localStorage.getItem('first_name');
      this.last_name = localStorage.getItem('last_name');
    }else{
      this.authService.getUserDetail().subscribe( 
        response => {
          this.first_name = response.first_name;
          this.last_name = response.last_name;
          localStorage.setItem('first_name', response.first_name);
          localStorage.setItem('last_name', response.last_name);
        },
        error => {
          console.log(error);
        }
      ); 
    }
    if (Capacitor.platform !== 'web') {
      PushNotifications.removeAllDeliveredNotifications();
    }
  }

  async getMessageUnReadCount(){
    await this.messageService.getUnreadCountMessages().subscribe( 
      response => {  
        this.unreadCount = response.data;
      },
      error => {
        console.log(error);
      }
    ); 
  }

  ngOnInit() {
    if (Capacitor.platform !== 'web') {
      PushNotifications.requestPermission().then( result => {
        if (result.granted) {
          // Register with Apple / Google to receive push via APNS/FCM
          PushNotifications.register();
        } else {
          // Show some error
        }
      });

      PushNotifications.addListener('pushNotificationReceived',
        (notification: PushNotification) => {
          this.changeBadgeCount(notification.data.badge);
        }
      );
    }
  }

  changeDarkMode(event){
    if (event.detail.checked) {
      localStorage.setItem('dark_mode', 'true');
      this.darkMode = true;
    }else{
      localStorage.setItem('dark_mode', 'false');
      this.darkMode = false;
    }
    document.body.classList.toggle('dark', this.darkMode);
    console.log("dark_mode_toggle_value-"+this.darkMode);
  }

  orderList(){
    this.router.navigate(['order-listing']); 
  }

  messageList(){
    this.router.navigate(['personal-messages']); 
  }

  changeBadgeCount(count){
    let badge_count = +localStorage.getItem('message_badge_count');
    let new_count = badge_count + 1;
    this.messageBadgeCount = new_count;
    localStorage.setItem('message_badge_count', new_count.toString());
    this.cdr.detectChanges();
  }

  async accountDelete(){
    const alert = await this.alertController.create({
      cssClass: 'new-message',
      message: '<p>Bist du dir sicher? <br>Sie möchten Ihr Konto löschen</p>',
      buttons: [
        {
          text: 'ABBRECHEN',
          role: 'cancel'
        }, {
          text: 'OK',
          handler: () => {
            this.deleteMessageRequest();
          }
        }
      ]
    });
    await alert.present();
  }
  
    deleteMessageRequest(){
      this.authService.deleteAccount().subscribe( 
        response => {     
          this.presentToast('Dein Account wurde gelöscht'); 
          localStorage.removeItem('first_name');
          localStorage.removeItem('last_name');
          localStorage.removeItem('auth_token');
          this.router.navigate(['home']);
      },
      error => {
        this.presentToast('Es tut uns leid! Bitte versuche es erneut');       
      })
    }

  backPage(){
    this.router.navigate(['home']);
  }

  backHome(){
    this.router.navigate(['home']);
  }

  logout(){
    this.authService.logout().subscribe( 
      response => {
        localStorage.removeItem('first_name');
        localStorage.removeItem('last_name');
        localStorage.removeItem('auth_token');
        this.router.navigate(['home']);
      },
      error => {
        this.presentToast(error.error.message);
      }
    ); 
  }

  async presentToast(error_msg) {
    const toast = await this.toastController.create({
      message: error_msg,
      duration: 2000
    });
    toast.present();
  }

}
